import {migrateTemplate} from './migrateTemplate';
import {normalizeTemplate} from './normalizeTemplate';
import type {QuoteTemplate} from '../resolver/types';

/**
 * The whole read path for a stored design payload, in one total function: null, empty,
 * unparseable, version-less and newer-than-current payloads all produce a usable template.
 *
 * A quote published before the payload existed simply reads as the fallback — today's behaviour,
 * and the reason no backfill is needed.
 */
export function readTemplate(json: string | null | undefined, fallback: QuoteTemplate): QuoteTemplate {
	if (!json || json.trim() === '') return fallback;
	let parsed: unknown;
	try {
		parsed = JSON.parse(json);
	} catch {
		return fallback;
	}
	if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
		return fallback;
	}
	return normalizeTemplate(migrateTemplate(parsed as Record<string, unknown>), fallback);
}
